import { countThursdaysAndSundays, getDeductDays } from "./helpers";

const LEAVE_TYPE_NAME_MAP = {
  1: "Casual",
  2: "Anual",
  3: "Sick",
  4: "Menstrual",
  5: "Maternity",
  6: "Reimburse",
};

export function calculateTotalLeaveDaysPerType(data, holidayss, makeupDayList) {
  const resultArray = [];

  data?.forEach((group) => {
    let totalDays = 0;

    group?.total?.forEach((range) => {
      const start = new Date(range?.start_date);
      const end = new Date(range?.end_date);

      let baseDays = getDeductDays(start, end, holidayss, makeupDayList);
      const weekendCount = countThursdaysAndSundays(start, end, holidayss);

      let adjustedDays = baseDays;

      if (weekendCount.total > 1) {
        adjustedDays += weekendCount.total;
      } else if (weekendCount.total === 1 && group?.leave_type === 3) {
        // Skip adding weekend for Sick leave
      } else {
        adjustedDays += weekendCount.total;
      }

      totalDays += adjustedDays;
    });

    const typeName = LEAVE_TYPE_NAME_MAP[group?.leave_type];
    if (typeName) {
      resultArray.push({
        id: group?.leave_type,
        [typeName]: totalDays,
      });
    }
  });

  return resultArray;
}
export function flattenPendingLeaveArray(pendingArray) {
  const result = {};

  pendingArray.forEach((item) => {
    const leaveTypeName = Object.keys(item).find((key) => key !== "id");
    if (leaveTypeName) {
      result[leaveTypeName] = item[leaveTypeName];
    }
  });

  return result;
}

export function flattenPendingArray(pendingArray) {
  const result = {};
  pendingArray?.forEach((item) => {
    const key = Object?.keys(item)?.find((k) => k !== "id");
    if (key) {
      result[key] = item[key];
    }
  });
  return result;
}
